import { _ as _objectSpread2 } from '../chunk-1b90139e.js';

var global = function global(overrides) {
  return _objectSpread2({
    fontSize: 16
  }, overrides);
};

export default global;